<div class="hotel-tour-skeleton">
  <div class="hotel-tour-bar">
    <div class="labels">
      <span class="label-skeleton skeleton-block"></span>
      <span class="label-skeleton skeleton-block" style="width: 60px"></span>
    </div>
  </div>

  <div class="hotel-tour__content">
    <div class="hotel-tour__items">
      <div class="hotel-tour__item">
        <span class="item-label skeleton-block"></span>
        <span class="item-value skeleton-block"></span>
      </div>
      <div class="hotel-tour__item">
        <span class="item-label skeleton-block"></span>
        <span class="item-value skeleton-block"></span>
      </div>
      <div class="hotel-tour__item">
        <span class="item-label skeleton-block"></span>
        <span class="item-value skeleton-block"></span>
      </div>
      <div class="hotel-tour__item">
        <span class="item-label skeleton-block"></span>
        <span class="item-value skeleton-block"></span>
      </div>
      <div class="hotel-tour__item">
        <span class="item-label skeleton-block"></span>
        <span class="item-value skeleton-block"></span>
      </div>
    </div>

    <div class="hotel-tour__footer">
      <div class="hotel-tour__price">
        <span class="old-price skeleton-block"></span>
        <span class="current skeleton-block"></span>
        <span class="cashback skeleton-block"></span>
      </div>

      <div class="buttons">
        <div class="btn-more-skeleton skeleton-block"></div>
      </div>
    </div>
  </div>
</div>
